export default {
  美元: '美元',
  人民币: '人民币',
  有效期: '有效期',
  暂无优惠: '暂无优惠',
  暂无优惠券: '暂无优惠券',
  领取成功: '领取成功!',
  '正在领取中,请稍等': '正在领取中,请稍等',
  产品优惠: '产品优惠',
  优惠券: '优惠券',
  应付货品金额标题: '应付货品金额（不包括运费）',
  券: '券',
  条件金额不能少于满减金额: '条件金额不能少于满减金额!',
  优惠券最多领取数: '优惠券最多领取数',
  天: '天',
  领取后X天有效: '领取后X天有效',
  固定时间: '固定时间',
  优惠券有效期模式: '优惠券有效期模式',
  打折设置: '打折设置',
  减: '减',
  满减设置: '满减设置',
  云优惠说明41: '优惠券说明不能超过500个字符！',
  云优惠说明40: '优惠券说明不能为空!',
  云优惠说明39: '可选择自定义描述该优惠券使用的一些特殊说明,例如仅限用于XX系列产品,或仅限于XXX服务等;',
  云优惠说明38: '优惠券最多领取数不能超过优惠券发行数量！',
  云优惠说明37: '优惠券最多领取数只能输入正整数！',
  云优惠说明36: '优惠券最多领取数不能超过5个字符！',
  云优惠说明35: '优惠券最多领取数不能为空!',
  云优惠说明34: '指的是每个客户最多可领取优惠券数,最小1张',
  云优惠说明33: '优惠券发行数量只能输入正整数！',
  云优惠说明32: '优惠券发行数量不能超过5个字符！',
  云优惠说明31: '优惠券发行数量不能为空!',
  云优惠说明50: '指的是发行的总数量,最小发行1张,最多99999张',
  云优惠说明30: '有效天数只能输入正整数！',
  云优惠说明29: '有效天数不能超过5个字符！',
  云优惠说明28: '有效天数不能为空!',
  云优惠说明27: '有效时间段不能为空!',
  云优惠说明26: '请选择优惠券有效时间模式!',
  云优惠说明25: '折扣范围必须为9.9-0.1范围内！',
  云优惠说明24: '满减设置不能为空!',
  云优惠说明23: '请填写数字,并只保留两位小数！',
  云优惠说明22: '满减设置不能超过9个字符！',
  云优惠说明21: '满减设置不能为空!',
  云优惠说明20: '若无门槛,可以输入满0减打xxx折,折扣范围必须为9.9-0.1范围内',
  云优惠说明19: '满减设置不能为空!',
  云优惠说明18: '请填写数字,并只保留两位小数！',
  云优惠说明17: '满减设置不能超过10个字符！',
  云优惠说明16: '满减设置不能为空!',
  云优惠说明15: '请填写数字,并只保留两位小数！',
  云优惠说明14: '满减设置不能超过10个字符！',
  云优惠说明13: '满减设置不能为空!',
  云优惠说明12: '若无门槛,可以输入满0减xxx',
  云优惠说明11: '满减设置不能为空!',
  云优惠说明10: '请选择优惠券币种!',
  云优惠说明9:
    '指的是该优惠券的优惠币种,人民币或美元,仅用于对应币种的产品SKU,例如：产品发布的币种为人民币,优惠券币种选择人民币,则可使用；若产品发布的币种为美元,而优惠券选择的是人民币,则不可使用；',
  云优惠说明8: '优惠券名称不能超过15个字符！',
  云优惠说明7: '优惠券名称不能为空!',

  云优惠说明6: '不对外显示,仅用于优惠券管理的显示,最多可输入15个字符',
  云优惠说明5:
    '注意：所有产品都可发布优惠券,优惠券将根据所选币种、满减金额条件自动适配产品,若产品的单价设为面议,将不可使用优惠券',
  提前结束成功: '提前结束成功',
  云优惠说明4: '结束该优惠券后无法领取,确定要结束吗？（已领取的优惠券仍然有效）',
  优惠券使用状态: '优惠券使用状态',
  注册账号: '注册账号（手机号/邮箱/子账号）',
  已失效: '已失效',
  失效: '失效',
  确定要失效此优惠券吗: '确定要失效此优惠券吗?',
  使用状态: '使用状态',
  人: '人',
  已领取优惠券: '已领取优惠券',
  查看: '查看',
  优惠券说明: '优惠券说明',
  优惠券发行数量: '优惠券发行数量',
  使用终端: '使用终端',
  提前结束: '提前结束',
  显示顺序不可重复: '显示顺序不可重复!',
  优惠券ID: '优惠券ID',
  优惠券名称: '优惠券名称',
  面额折扣: '面额/折扣',
  已领取人数: '已领取人数',
  创建折扣优惠券: '创建折扣优惠券',
  创建满减优惠券: '创建满减优惠券',
  云优惠说明3: '您所发布的优惠券,可以查看客户的领取记录,也可以主动将已领取的优惠券置为失效（请谨慎使用该功能）；',
  云优惠说明2: '新发布的优惠券直接自动默认关联您企业所发布的所有产品,客户领取后,可在意向采购单进行使用；',
  云优惠说明1: '您可以设置优惠券的顺序,数字越大越靠前,在您的企业云展系统则优先排序数字越大的优惠券；',
  折扣券: '折扣券',
  满减券: '满减券',
  展览券: '展览券',
  平台券: '平台券',
  产品券: '产品券',
  可用: '可用',
  满: '满',
  优惠券币种: '优惠券币种',
  有效时间: '有效时间',
  复制成功: '复制成功',
  券码: '券码',
  领取时间: '领取时间',
  折: '折',
  已领取: '已 领 取',
  立即领取: '立 即 领 取',
  立即使用: '立 即 使 用',
  我的优惠券说明2:
    '自定义优惠券,指的是企业商家创建使用范围不确定的一种优惠券,可与企业商家进行洽谈沟通,确定使用范围,例如企业商家产品与服务的优惠；',
  我的优惠券说明1: '若领取的优惠券类型配置为：自定义,在与企业商家沟通达成结果后,可复制券码给企业商家核销；',
  适用的产品: '适用的产品',
  适用的展览: '适用的展览',
  未使用: '未使用',
  已使用: '已使用',
  已过期: '已过期',
}
